up.compiler('.mobile_navigation_icon', function (element) {
  var $element = $(element)
  if ($element.is(":visible")) {
    var $navigation = $element.siblings('.account_navigation');
    $element.on('click', function (event) {
      $navigation.toggleClass('hidden');
      event.stopPropagation();
    });
    $(window).click(function () {
      if (!$navigation.hasClass('hidden')) {
        $navigation.addClass('hidden');
      }
    });
  }
});
